import { render } from "./reporterApplySchool.vue?vue&type=template&id=846c55c6&scoped=true"
import script from "./reporterApplySchool.vue?vue&type=script&lang=js"
export * from "./reporterApplySchool.vue?vue&type=script&lang=js"

import "./reporterApplySchool.vue?vue&type=style&index=0&id=846c55c6&lang=less&scoped=true"
import "./reporterApplySchool.vue?vue&type=style&index=1&id=846c55c6&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846c55c6"]])

export default __exports__